module.exports = __webpack_public_path__ + "img/title-dver-2@3x.d89de529.png";